import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-gray-100 border-t border-gray-200 pt-16 pb-28 md:pb-8 overflow-hidden" data-testid="footer">
      {/* Background Text */}
      <div className="footer-bg-text">GIANT FITNESS</div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <img 
              src="/images/GiantFitness-more-equipment-no-waiting-LOGO.png" 
              alt="Giant Fitness" 
              className="h-10 w-auto mb-4"
            />
            <p className="text-gray-600 text-sm leading-relaxed">
              Your local fitness destination. Multiple locations across New Jersey and Philadelphia with a GIANT selection of premium fitness equipment.
            </p>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-gray-900 font-heading text-lg uppercase tracking-wider mb-4">Support</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/support" className="text-gray-600 hover:text-brand-orange transition-colors text-sm" data-testid="footer-support-link">
                  Support
                </Link>
              </li>
              <li>
                <Link to="/feedback" className="text-gray-600 hover:text-brand-orange transition-colors text-sm" data-testid="footer-feedback-link">
                  Feedback
                </Link>
              </li>
              <li>
                <Link to="/cancel" className="text-gray-600 hover:text-brand-orange transition-colors text-sm" data-testid="footer-cancellation-link">
                  Cancellation Request
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-600 hover:text-brand-orange transition-colors text-sm" data-testid="footer-privacy-link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 hover:text-brand-orange transition-colors text-sm" data-testid="footer-terms-link">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-gray-900 font-heading text-lg uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <Phone className="w-4 h-4 text-brand-orange flex-shrink-0" />
                <a href="tel:+18563820555" className="hover:text-brand-orange transition-colors">(856) 382-0555</a>
              </li>
              <li className="flex items-center gap-3 text-gray-700 text-sm">
                <Mail className="w-4 h-4 text-brand-orange flex-shrink-0" />
                <a href="mailto:contact@giantfitnessclubs.com" className="hover:text-brand-orange transition-colors">
                  contact@giantfitnessclubs.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-600 text-sm">
                <MapPin className="w-4 h-4 text-brand-orange flex-shrink-0 mt-0.5" />
                <span>Multiple locations across New Jersey and Philadelphia</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-600 text-sm">
            © {currentYear} Giant Fitness, Philly Girls, and Jersey Girls. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/terms" className="text-gray-600 hover:text-brand-orange text-sm transition-colors">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
